<div class="d-flex flex-1 align-items-center justify-content-center">
  <form [formGroup]="addPartnerForm" class="w-100">
    @if (addPartnerForm.controls.email?.hasError('invalidOktaChars')) {
      <p-message severity="error" class="partner-message d-block mb-3">
        <div class="d-flex flex-grow-1 align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="pi pi-info-circle fs-4"></i>
            <span class="ms-2 error-message"
              >Special characters in the email can only include: &#64; ! # $ % & ' * + - / = ? ^ _ ` . &#123; | &#125; ~</span
            >
          </div>
        </div>
      </p-message>
    }
    @if (addPartnerError) {
      <p-message severity="error" class="partner-message d-block mb-3">
        <div class="d-flex flex-grow-1 align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="pi pi-info-circle fs-4"></i>
            <span class="ms-2 error-message">{{ addPartnerError }}</span>
          </div>
        </div>
      </p-message>
    }
    <div class="row">
      @if (showLoanOfficer) {
        <div class="col-12 mb-3 form-group" [attr.automation-id]="autoIdPrefix + 'loanOfficer' | qaSlug">
          <label for="loanOfficer" class="w-100 control-label">Loan Officer <span class="color-danger">*</span></label>
          <p-select
            [options]="loanOfficers"
            [optionLabel]="'username'"
            [optionValue]="'nmlsid'"
            formControlName="loanOfficer"
            class="w-100"
            [filter]="true"
            [virtualScroll]="true"
            virtualScrollItemSize="30"
            appendTo="body"
          >
            <ng-template pTemplate="item" let-option>
              <span>{{ option.username || '&nbsp;' }}</span>
            </ng-template>
          </p-select>
          <cmg-validator-messages [control]="addPartnerForm.get('loanOfficer')" />
        </div>
      }
      <div class="col-12 mb-3 form-group" [attr.automation-id]="autoIdPrefix + 'partnerType' | qaSlug">
        <label for="partnerType" class="w-100 control-label"
          >Partner Type
          <i
            pTooltip="Real Estate Agent is the only supported partner type at this time"
            tooltipPosition="right"
            tooltipStyleClass="cobranding-tooltip"
            class="pi pi-info-circle info-icon pe-auto"
          ></i
        ></label>
        <p-select
          [options]="partnerTypeOptions"
          [optionLabel]="'name'"
          [optionValue]="'id'"
          formControlName="partnerType"
          class="w-100"
          [filter]="true"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
        />
        <cmg-validator-messages [control]="addPartnerForm.get('partnerType')" />
      </div>
      <div class="col-12 mb-3 form-group" [attr.automation-id]="autoIdPrefix + 'email' | qaSlug">
        <label class="control-label" for="email">Partner Email <span class="color-danger">*</span></label>
        <input pInputText name="email" class="txt-box form-control" formControlName="email" id="{{ autoIdPrefix + 'email' }}" maxlength="50" />
        <cmg-validator-messages [control]="addPartnerForm.get('email')" />
      </div>
    </div>
  </form>
</div>
<div class="dialog-button-container">
  <div class="mx-1">
    <button pButton severity="secondary" [disabled]="isLoading()" (click)="closeModal()" label="Cancel"></button>
  </div>
  <div class="mx-1">
    <button pButton severity="primary" [disabled]="isLoading()" [loading]="isLoading()" (click)="addPartner()" label="Add Partner"></button>
  </div>
</div>
